/* eslint-disable */

import React, { Component } from 'react';
import { isTrue } from '../../helpers/isTrue';
import SearchDropdown from '../../modules/SearchDropdown';
import ActivatePlanComponent from '../../modules/ActivatePlanComponent';
import StripeMessage from '../StripeMessage';
import Sidebar from './Sidebar';
import TopMenu from './TopMenu';
import { setView } from './query';
import {
    BadgeDollarSign,
    FileText,
    Landmark,
    UserSearch,
    UsersRound,
    Wallet,
    WalletCards,
} from 'lucide-react';
import { changeLanguage } from '../../translation/functions';

class Layout extends Component {
    constructor(props) {
        super();
        this.classTypes = ['menu-version', 'mini-menu'];

        this.body = document.getElementsByTagName('body')[0];
        this.changeMoodEvent = new Event('changeMoodEvent');
        this.changeDomainVisibilityEvent = new Event('changeDomainVisibilityEvent');

        this.toggleMode = this.toggleMode.bind(this);
        this.updateStyle = this.updateStyle.bind(this);
        this.toggleResponsiveTopMenu = this.toggleResponsiveTopMenu.bind(this);
        this.toggleDomainVisibility = this.toggleDomainVisibility.bind(this);

        // const defaultMode = localStorage.getItem('dark-mode');
        const defaultMode = false;

        const isHiddenDomain = localStorage.getItem('hide-domain');
        let modeIconClassName = 'icon-moon';
        let control_domain_btn_name = 'Hide domain';

        if (isHiddenDomain === 'true') {
            control_domain_btn_name = 'Show Domain';
            this.body.classList.add('hide-domain');
        }

        if (defaultMode === 'true') {
            modeIconClassName = 'icon-sun';
            this.body.classList.add('dark-mode');
        }

        this.state = {
            has_commerce: isTrue(props.has_commerce),
            is_superuser: isTrue(props.is_superuser),
            dont_show_domain: isTrue(props.dont_show_domain),
            need_onboard: isTrue(props.need_onboard),
            control_domain_btn_name: control_domain_btn_name,
            modeIconClassName,
            activate_plan_btn: false,
            demo_button: false,
            isNotViewer: !!window.is_not_viewer,
            openResponsiveTopMenu: false,
        };
    }

    async componentDidMount() {
        try {
            const res = await fetch('/customers/account-status/', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': window.csrf_token,
                },
            });
            const data = await res.json();
            if (data?.sub_status === 'trialing') {
                this.setState({
                    activate_plan_btn: true,
                });
            } else {
                this.setState({
                    demo_button: true,
                });
            }
        } catch (err) {
            console.log(err);
        }
    }

    toggleResponsiveTopMenu() {
        this.setState({
            openResponsiveTopMenu: !this.state.openResponsiveTopMenu,
        });
    }

    toggleMode() {
        const isContain = this.body.classList.contains('dark-mode');

        if (isContain) {
            this.body.classList.remove('dark-mode');
            localStorage.setItem('dark-mode', false);
            document.dispatchEvent(this.changeMoodEvent);
            this.setState({
                modeIconClassName: 'icon-moon',
            });
        } else {
            this.body.classList.add('dark-mode');
            localStorage.setItem('dark-mode', true);
            document.dispatchEvent(this.changeMoodEvent);
            this.setState({
                modeIconClassName: 'icon-sun',
            });
        }
    }

    toggleDomainVisibility() {
        const isContain = this.body.classList.contains('hide-domain');

        if (isContain) {
            this.body.classList.remove('hide-domain');
            localStorage.setItem('hide-domain', false);
            document.dispatchEvent(this.changeDomainVisibilityEvent);
            this.setState({
                control_domain_btn_name: 'Hide domain',
            });
        } else {
            this.body.classList.add('hide-domain');
            localStorage.setItem('hide-domain', true);
            document.dispatchEvent(this.changeDomainVisibilityEvent);
            this.setState({
                control_domain_btn_name: 'Show Domain',
            });
        }
    }

    toggleFullScreen() {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else if (document.exitFullscreen) {
            document.exitFullscreen();
        }
    }

    updateStyle(value) {
        const sidebarContainer = document.querySelector('.sidebar-container');
        if (sidebarContainer.classList.contains(value)) {
            setView({ view: 'standard' });
            return sidebarContainer.classList.remove(value);
        }
        this.classTypes.forEach((item) => {
            sidebarContainer.classList.remove(item);
        });
        sidebarContainer.classList.add(value);
        setView({ view: value });
    }

    changeLanguage() {
        const key = 'de';
        changeLanguage(key);
    }

    render() {
        return (
            <>
                <div
                    className={`sidebar ${
                        this.state.openResponsiveTopMenu ? 'sidebar-from-top-menu' : ''
                    }`}
                    id="nav-bar"
                >
                    <ul className={`list-group`}>
                        <li
                            className="centered d-flex align-items-center justify-content-between border-bottom top-part"
                            style={{ textAlign: 'center' }}
                        >
                            <a href="/" className="logo">
                                <img
                                    className="logo-sidebar logo-symbol"
                                    loading="lazy"
                                    alt="logo"
                                    src="/static/img/gddash_logo1.png"
                                />
                                <img
                                    className="logo-sidebar-mini logo-symbol"
                                    loading="lazy"
                                    alt="logo"
                                    src="/static/img/logo-symbol.svg"
                                />
                            </a>
                            <button
                                className="navbar-toggler"
                                id="toggleId"
                                onClick={this.toggleResponsiveTopMenu}
                            >
                                <div id="header-toggle">
                                    <i className="icon-angle-double-left"></i>
                                </div>
                            </button>
                        </li>
                        <Sidebar
                            has_commerce={this.state.has_commerce}
                            default_domain_id={this.props.default_domain_id}
                            domain_id={this.props.domain_id}
                            updateStyle={this.updateStyle}
                        />
                    </ul>
                </div>
                <header className="header-primary border-bottom">
                    <div className="content-left">
                        <a href="/" className="logo ">
                            <img
                                className="logo-symbol logo-menu"
                                loading="lazy"
                                alt="logo"
                                src="/static/img/gddash_logo1.png"
                            />
                            <img
                                className="logo-menu-mini logo-symbol"
                                loading="lazy"
                                alt="logo"
                                src="/static/img/logo-symbol.svg"
                            />
                        </a>
                        {this.props.domains_for_dropdown && !this.state.dont_show_domain && (
                            <SearchDropdown
                                domains={this.props.domains_for_dropdown}
                                domain="{{domain}}"
                                is_superuser={this.props.is_superuser}
                                domain_id={this.props.domain_id}
                                domain_name={this.props.domain_name}
                            />
                        )}
                    </div>
                    <div className="content-right">
                        <ul className="list-group list-group-horizontal nav-items d-flex align-items-center">
                            {this.state.need_onboard && (
                                <li className="list-group">
                                    <a
                                        href="/customers/onboarding/"
                                        className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center"
                                        style={{ background: '#bb1f44' }}
                                    >
                                        Complete your setup
                                    </a>
                                </li>
                            )}
                            {this.state.demo_button && (
                                <li className="list-group schedule-a-training-btn">
                                    <a
                                        className="button button-outline button-primary width-sm btn d-flex align-items-center justify-content-center schedule-training-btn"
                                        target="_blank"
                                        rel="noreferrer"
                                        title="Schedule a Training"
                                        href="https://calendly.com/newzdash/gddash-training"
                                    >
                                        <i className="icon-calendar1" />
                                        <span>Schedule a Training</span>
                                    </a>
                                </li>
                            )}
                            {this.state.activate_plan_btn && (
                                <li className="list-group activate-plane-component">
                                    <ActivatePlanComponent />
                                </li>
                            )}

                            <li className="list-group">
                                <a className="btn-icon" href="/support/release-notes">
                                    <i className="icon-fi_bell nav-icon"></i>
                                </a>
                            </li>
                            <li className="list-group">
                                <button className="btn-icon" onClick={this.toggleFullScreen}>
                                    <i className="icon-fullscreen nav-icon"></i>
                                </button>
                            </li>
                            <li className="list-group">
                                <a className="btn-icon" href="/support">
                                    <i className="icon-help-circle_1 nav-icon"></i>
                                </a>
                            </li>
                            {/* <li className="list-group">
                                <button className="btn-icon" onClick={this.toggleMode}>
                                    <i id="mode-icon" className={this.state.modeIconClassName}></i>
                                </button>
                            </li> */}
                            {/* {this.props.domain_name && (
                                <li className="list-group">
                                    <div className="circle-with-content">
                                        <DomainImage domain_name={this.props.domain_name} />
                                    </div>
                                </li>
                            )} */}
                            <li className="list-group">
                                <ul className="list-group settings">
                                    <li className="d-flex justify-content-between align-items-center">
                                        <div className="dropdown ">
                                            <a
                                                className="list-group-item-action"
                                                href="#"
                                                role="button"
                                                id="dropdownMenuLink"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                <i className="icon-settings1 nav-icon"></i>
                                            </a>
                                            <ul
                                                className="dropdown-menu settings-menu"
                                                aria-labelledby="dropdownMenuLink"
                                            >
                                                {this.state.is_superuser && (
                                                    <>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/customers/list/?customer_type=active_customers"
                                                            >
                                                                <UsersRound />
                                                                Customers
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/domains/gsc-test-data/"
                                                            >
                                                                <i className="icon-Icon-Stroke"></i>
                                                                GSC Test
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/domains/scrap-pages-test/"
                                                            >
                                                                <i className="icon-Icon-Stroke-1"></i>
                                                                Test Page Scraper
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/domains/get-domain-per-user/"
                                                            >
                                                                <i className="icon-Icon-Stroke-2"></i>
                                                                Domain Runs QA
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/domains/without-data/"
                                                            >
                                                                <i className="icon-n_author-performance-1"></i>
                                                                Domains missing entities
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/customers/bulk-plan-change/"
                                                            >
                                                                <FileText />
                                                                Bulk Plan Change
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/customers/user-activities/"
                                                            >
                                                                <i className="icon-n_author-performance-1"></i>
                                                                User Activities
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a
                                                                className="dropdown-item"
                                                                href="/halubcnd"
                                                            >
                                                                <i className="icon-Group-1000001833"></i>
                                                                Admin
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <button
                                                                className="dropdown-item"
                                                                id="domain-control-btn"
                                                                onClick={
                                                                    this.toggleDomainVisibility
                                                                }
                                                            >
                                                                <i className="icon-Vector-4"></i>
                                                                {this.state.control_domain_btn_name}
                                                            </button>
                                                        </li>
                                                    </>
                                                )}
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        href="/customers/change_customer_profile"
                                                    >
                                                        <i className="icon-Vector-Stroke-5"></i>
                                                        My Profile
                                                    </a>
                                                </li>
                                                <li>
                                                    <a className="dropdown-item" href="/settings">
                                                        <i className="icon-Icon-Stroke"></i>
                                                        Settings
                                                    </a>
                                                </li>
                                                {!this.state.is_superuser &&
                                                    this.state.isNotViewer && (
                                                        <>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item"
                                                                    href="/customers/payment-methods"
                                                                >
                                                                    <BadgeDollarSign />
                                                                    Payment methods
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item"
                                                                    href={`/customers/change_plan/`}
                                                                >
                                                                    <Wallet />
                                                                    Change Plan
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item"
                                                                    href={`/customers/licenses/`}
                                                                >
                                                                    <Landmark />
                                                                    Billing History
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item"
                                                                    href="/domains/get-user-domains/"
                                                                >
                                                                    <UserSearch />
                                                                    GSC Search Data Import
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a
                                                                    className="dropdown-item"
                                                                    href="/tools/purchase-more-entity/"
                                                                >
                                                                    <WalletCards />
                                                                    Add-ons
                                                                </a>
                                                            </li>
                                                        </>
                                                    )}
                                                {this.state.has_commerce && (
                                                    <li>
                                                        <a
                                                            className="dropdown-item"
                                                            href="/commerce/settings/"
                                                        >
                                                            <i className="icon-Icon-Stroke"></i>
                                                            Commerce settings
                                                        </a>
                                                    </li>
                                                )}
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        href="/accounts/logout?next=/account/login"
                                                    >
                                                        <i className="icon-Vector-Stroke-6"></i>
                                                        Sign Out
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </header>
                <TopMenu
                    has_commerce={this.state.has_commerce}
                    default_domain_id={this.props.default_domain_id}
                    domain_id={this.props.domain_id}
                    updateStyle={this.updateStyle}
                    toggleResponsiveTopMenu={this.toggleResponsiveTopMenu}
                />
                <StripeMessage />
            </>
        );
    }
}

export default Layout;
